import React from 'react';
import {
    ExportOutlined,
    ImportOutlined,
    MoreOutlined,
    PlusOutlined
} from '@ant-design/icons';
import { Button, Input, InputNumber, message, Modal, Table, Divider, Dropdown, Menu } from 'antd';
import { Api } from '../../../lib/api';

import '../styles.scss';
import { CONNECTORS } from '../components/pageNameConstants';
import DeleteWarningModal from '../components/DeleteWarningModal';
import { downloadFile, importFile } from '../../../lib/utils';

interface ConnectorsState {
    selectedConnector: string | null;
    connectors: Array<any>;
    name: string | null;
    mapping: Array<any>;
    tableIndex: number; // page?
    il: number | null;
    rl: number | null;
    visible: boolean;
    editVisible: boolean;
    tconnectorVisible: boolean;
    tconnectorResult: any;
    tconnectorError: boolean;
    mssqlDatabase: string;
    username: string;
    password: string;
    host: string;
    port: string;
    loading: boolean;
    showDeleteModal: boolean;
    currentRecordName?: string;
    currentRecordId?: number;
    selectedRowKeys?: React.Key[];
    selectedRows?: any;
}

export default class Connectors extends React.PureComponent {
    state: ConnectorsState = {
        selectedConnector: null,
        connectors: [],
        name: null,
        mapping: [],
        tableIndex: 0,
        il: 0,
        rl: 10,
        visible: false,
        editVisible: false,

        // legacy Tconnector import
        tconnectorVisible: false,
        tconnectorResult: null,
        tconnectorError: false,
        mssqlDatabase: '',
        username: '',
        password: '',
        host: '',
        port: '',
        loading: false,
        showDeleteModal: false,
        selectedRows: []
    };

    updateConnectors = async () => {
        await Api.getConnectors().then((connectors) => {
            let newState = {
                connectors: connectors.sort((a, b) => a.name.localeCompare(b.name)),
                selectedRows: this.state.selectedRows?.filter(row => connectors.some(connector => connector.id === row.id)) || [],
                selectedRowKeys: this.state.selectedRowKeys?.filter(key => connectors.some(connector => connector.name === key)) || []
            };

            console.debug(newState);

            this.setState(newState);
        });
    }

    deleteConnectors = (id) => {
        return Api.deleteConnector(id);
    }

    componentDidMount() {
        this.updateConnectors();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedConnector !== prevState.selectedConnector) {
            let connector = this.state.connectors.find((connector) => connector.id === this.state.selectedConnector);
            if (connector) {
                this.setState((state: ConnectorsState) => ({
                    il: connector.mapping[0].il,
                    rl: connector.mapping[0].rl,
                    tableIndex: state.tableIndex + 1
                }));
            }
        }
    }
    showModal = () => {
        this.setState({
            name: null,
            il: 0,
            rl: 10,
            visible: true
        });
    };
    handleCancel = (e) => {
        this.setState((state: ConnectorsState) => ({
            name: null,
            il: 0,
            rl: 10,
            tableIndex: state.tableIndex + 1,
            visible: false,
            editVisible: false
        }));
    };
    closeDeleteModal = () => {
        this.setState({showDeleteModal: false});
    }
    render() {
        return (
            <div className="section connectors page-card">
                <div className="create-button">
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Button
                            shape='round'
                            onClick={() => {
                                this.setState({ selectedRows: [], selectedRowKeys: [] });
                            }}
                            style={{ display: this.state.selectedRows && this.state.selectedRows.length > 0 ? undefined : 'none' }}
                        >
                            Clear Selection
                        </Button>
                        <Button
                            type="primary"
                            shape='round'
                            icon={<ExportOutlined />}
                            onClick={() => {
                                let selectedRowIds = this.state.selectedRows.map(row => row.id);

                                const selectedFields = this.state.connectors
                                    .filter(connector => selectedRowIds?.includes(connector.id))
                                    .map(connector => ({ name: connector.name, mapping: connector.mapping }));

                                let fileName = '';
                                if(selectedRowIds.length === 1) {
                                    fileName = `connector-${selectedFields[0].name}.json`;
                                } else if (selectedRowIds.length > 1) {
                                    fileName = 'selected_connectors.json';
                                } else {
                                    message.error('No connectors selected for export');
                                    return;
                                }

                                downloadFile(fileName, selectedFields, 'application/json');

                                this.setState({ selectedRows: [], selectedRowKeys: [] });
                            }}
                            style={{ display: this.state.selectedRows && this.state.selectedRows.length > 0 ? undefined : 'none' }}
                        >
                            Export Selected ({this.state.selectedRows?.length})
                        </Button>
                        <Button
                            shape="round"
                            icon={<ImportOutlined />}
                            onClick={() => {
                                importFile((file) => {
                                    let reader = new FileReader();
                                    reader.onload = async (e) => {
                                        try {
                                            const importedFile = JSON.parse(e.target?.result as string);

                                            const { createdConnectors, skippedConnectors } = await Api.importConnectors({ connectors: importedFile });

                                            if (createdConnectors.length > 0 && skippedConnectors.length === 0) {
                                                message.success(`Successfully imported ${createdConnectors.length} connector(s)`, 5);
                                            } else if (createdConnectors.length > 0 && skippedConnectors.length > 0) {
                                                message.success(`Imported ${createdConnectors.length} connector(s). Skipped ${skippedConnectors.length} (identical entries already exist)`, 5);
                                            } else if (skippedConnectors.length > 0) {
                                                message.info(`All ${skippedConnectors.length} connector(s) already exist with identical mappings. Nothing imported.`, 5);
                                            }

                                            this.updateConnectors();
                                        } catch (error) {
                                            message.error('Import failed. Please ensure the file is a valid connector export.', 5);
                                            return;
                                        }
                                    };

                                    reader.readAsText(file);
                                });
                            }}
                            style={{ display: this.state.selectedRows && this.state.selectedRows.length > 0 ? 'none' : undefined }}
                        >
                            Import
                        </Button>
                        <Button
                            shape="round"
                            icon={<ImportOutlined />}
                            onClick={() => this.setState({ tconnectorVisible: true })}
                            style={{ display: this.state.selectedRows && this.state.selectedRows.length > 0 ? 'none' : undefined }}
                        >
                            Import Legacy
                        </Button>
                        <Button
                            type="primary"
                            shape="round"
                            icon={<PlusOutlined />}
                            onClick={this.showModal}
                            style={{ display: this.state.selectedRows && this.state.selectedRows.length > 0 ? 'none' : undefined }}
                        >
                            New Connector
                        </Button>
                    </div>
                </div>
                {this.state.connectors && (
                    <Table
                        columns={[
                            {
                                title: 'Name',
                                dataIndex: 'name',
                                key: 'name',
                                render: (text, record) => <div>{text}</div>
                            },
                            {
                                title: 'IL',
                                dataIndex: 'il',
                                key: 'il',
                                render: (text, record) => <p> &le;&nbsp; {record.mapping[0].il}</p>
                            },
                            {
                                title: 'RL',
                                dataIndex: 'rl',
                                key: 'rl',
                                render: (text, record) => <p> &ge;&nbsp; {record.mapping[0].rl}</p>
                            },
                            {
                                title: 'Action',
                                key: 'action',
                                render: (text, record) => (
                                    <div className="action-buttons">
                                        <Button
                                            type="link"
                                            style={{ color: '#40a9ff' }}
                                            onClick={() => {
                                                this.setState({
                                                    selectedConnector: record.id,

                                                    name: record.name,
                                                    mapping: record.mapping,
                                                    il: record.mapping[0].il,
                                                    rl: record.mapping[0].rl,
                                                    editVisible: true
                                                });
                                            }}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            type="link"
                                            style={{ color: '#40a9ff' }}
                                            onClick={() => {
                                                downloadFile(
                                                    `connector-${record.name}.json`,
                                                    [{ name: record.name, mapping: record.mapping }],
                                                    'application/json'
                                                );
                                            }}
                                        >
                                            Export
                                        </Button>
                                        <Divider type="vertical" />
                                        <Button
                                            type="link"
                                            style={{ color: '#e60013' }}
                                            onClick={() => {
                                                this.setState({
                                                    showDeleteModal: true,
                                                    currentRecordId: record.id,
                                                    currentRecordName: record.name
                                                });
                                            }}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                )
                            }
                        ]}
                        rowSelection={{
                            selectedRowKeys: this.state.selectedRowKeys,
                            onChange: (selectedRowKeys, selectedRows) => {
                                this.setState({ selectedRowKeys, selectedRows });
                            }
                        }}
                        dataSource={this.state.connectors}
                        pagination={{ pageSize: 8 }}
                        rowKey="name"
                    />
                )}
                {this.state.tconnectorVisible && (
                    <Modal
                        title={
                            <div>{this.state.tconnectorResult === null ? <div>Authentication </div> : <div>Done </div>}</div>
                        }
                        //wrapClassName="legacy-import-model"
                        open={this.state.tconnectorVisible}
                        onCancel={() =>
                            this.setState({
                                tconnectorVisible: false,
                                tconnectorError: false,
                                mssqlDatabase: '',
                                username: '',
                                password: '',
                                host: '',
                                port: '',
                                tconnectorResult: null
                            })
                        }
                        closable={true}
                        destroyOnClose={true}
                        mask={true}
                        footer={
                            this.state.tconnectorResult === null && (
                                <Button
                                    type="primary"
                                    loading={this.state.loading}
                                    onClick={() => {
                                        this.setState({ loading: true });
                                        Api.validateMigration({
                                            mssqlDatabase: this.state.mssqlDatabase,
                                            userName: this.state.username,
                                            password: this.state.password,
                                            host: this.state.host,
                                            port: this.state.port ? this.state.port : '1433',
                                            instanceName: ''
                                        }).then((result) => {
                                            if (result === true) {
                                                Api.importTconnectors({
                                                    mssqlDatabase: this.state.mssqlDatabase,
                                                    userName: this.state.username,
                                                    password: this.state.password,
                                                    host: this.state.host,
                                                    port: this.state.port,
                                                    instanceName: ''
                                                }).then((res) => {
                                                    this.setState({ tconnectorResult: res, loading: false });
                                                    this.updateConnectors();
                                                });
                                            } else {
                                                this.setState({ tconnectorError: true, loading: false });
                                            }
                                        });
                                    }}
                                >
                                    submit
                                </Button>
                            )
                        }
                    >
                        {this.state.tconnectorResult === null ? (
                            <div>
                                {this.state.tconnectorError === true && (
                                    <p style={{ color: '#e60013' }}> Error : Invalid Input</p>
                                )}
                                <div className="title">Username:</div>
                                <Input
                                    defaultValue={this.state.username}
                                    onChange={(e) => this.setState({ username: e.target.value })}
                                />
                                <div className="title">Password:</div>
                                <Input.Password
                                    defaultValue={this.state.password}
                                    onChange={(e) => this.setState({ password: e.target.value })}
                                />
                                <div className="title">Database Name:</div>
                                <Input
                                    defaultValue={this.state.mssqlDatabase}
                                    onChange={(e) => this.setState({ mssqlDatabase: e.target.value })}
                                />
                                <div className="title">Server IP:</div>
                                <Input
                                    defaultValue={this.state.host}
                                    onChange={(e) => this.setState({ host: e.target.value })}
                                />
                                <div className="title">Port (optional):</div>
                                <Input
                                    placeholder="Default port is 1433"
                                    defaultValue={this.state.port}
                                    onChange={(e) => this.setState({ port: e.target.value })}
                                />
                            </div>
                        ) : (
                            <div>
                                {Object.keys(this.state.tconnectorResult).map((name, index) => {
                                    return (
                                        <div key={index}>
                                            <span style={{ fontWeight: 'bold' }}>{name}</span>:<span>{index}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </Modal>
                )}
                {this.state.visible && (
                    <Modal
                        title="Create Connector"
                        open={this.state.visible}
                        onCancel={this.handleCancel}
                        footer={
                            <div className="footer">
                                <div className="buttons">
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            console.debug(this.state);
                                            Api.createConnector({
                                                name: this.state.name,
                                                mapping: [{ il: this.state.il, rl: this.state.rl }]
                                            })
                                                .then((connector) => {
                                                    message.success('Save successful', 3);
                                                    this.setState({
                                                        createNew: false,
                                                        selectedConnector: connector.id,
                                                        visible: false,
                                                        name: null,
                                                        il: null,
                                                        rl: null
                                                    });
                                                    this.updateConnectors();
                                                })
                                                .catch(() => {
                                                    message.error('Save failed');
                                                });
                                        }}
                                    >
                                        Create
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            let connector = this.state.connectors.find(
                                                (connector) => connector.id === this.state.selectedConnector
                                            );

                                            this.setState((state: ConnectorsState) => ({
                                                name: null,
                                                createNew: false,
                                                il: connector ? connector.mapping.il : null,
                                                rl: connector ? connector.mapping.rl : null,
                                                tableIndex: state.tableIndex + 1,
                                                visible: false
                                            }));
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        }
                    >
                        <React.Fragment>
                            <div className="title">Connector Type:</div>

                            <Input
                                defaultValue={this.state.name ?? ''}
                                onChange={(e) => this.setState({ name: e.target.value })}
                                autoFocus
                            />

                            <React.Fragment key={this.state.tableIndex}>
                                <div className="connector-mapping-table">
                                    <div>
                                        <div className="title">IL &le;&nbsp;</div>
                                        <InputNumber
                                            value={this.state.il ?? 0}
                                            onChange={(value) => this.setState({ il: value })}
                                            min={0}
                                            required
                                        />
                                    </div>
                                    <div>
                                        <div className="title">RL &ge;&nbsp;</div>
                                        <InputNumber
                                            value={this.state.rl ?? 10}
                                            onChange={(value) => this.setState({ rl: value })}
                                            min={10}
                                            required
                                        />
                                    </div>
                                </div>
                            </React.Fragment>
                        </React.Fragment>
                    </Modal>
                )}
                <DeleteWarningModal
                    isOpen={this.state.showDeleteModal}
                    itemTypeToDelete={CONNECTORS}
                    itemNameToDelete={this.state.currentRecordName || ''}
                    itemRecordToDelete={this.state.currentRecordId || 0}
                    closeCallback={this.closeDeleteModal}
                    update={this.updateConnectors}
                    delete={this.deleteConnectors}
                >
                </DeleteWarningModal>
                {this.state.editVisible && (
                    <Modal
                        title="Edit Connector"
                        open={this.state.editVisible}
                        onCancel={this.handleCancel}
                        footer={
                            <div className="footer">
                                <div className="buttons">
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            Api.updateConnector(this.state.selectedConnector, {
                                                name: this.state.name,
                                                mapping: [{ il: this.state.il, rl: this.state.rl }]
                                            })
                                                .then(() => {
                                                    message.success('Save successful', 3);
                                                    this.updateConnectors();
                                                })
                                                .catch(() => {
                                                    message.error('Save failed');
                                                });
                                            this.setState({
                                                editVisible: false
                                            });
                                        }}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                editVisible: false
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        }
                    >
                        <React.Fragment>
                            <div className="title">Connector Type:</div>
                            <Input
                                defaultValue={this.state.name ?? ''}
                                onChange={(e) => this.setState({ name: e.target.value })}
                                autoFocus
                            />

                            <React.Fragment key={this.state.tableIndex}>
                                <div className="connector-mapping-table">
                                    <div>
                                        <div className="title">IL &le;&nbsp;</div>
                                        <InputNumber
                                            defaultValue={this.state.il ?? 0}
                                            onChange={(value) => this.setState({ il: value })}
                                            min={0}
                                        />
                                    </div>
                                    <div>
                                        <div className="title">RL &ge;&nbsp;</div>
                                        <InputNumber
                                            defaultValue={this.state.rl ?? 10}
                                            onChange={(value) => this.setState({ rl: value })}
                                            min={10}
                                        />
                                    </div>
                                </div>
                            </React.Fragment>
                        </React.Fragment>
                    </Modal>
                )}
            </div>
        );
    }
}